import { render } from "./NumberInput.vue?vue&type=template&id=4284998c"
import script from "./NumberInput.vue?vue&type=script&lang=js"
export * from "./NumberInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/NumberInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4284998c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4284998c', __exports__)) {
    api.reload('4284998c', __exports__)
  }
  
  module.hot.accept("./NumberInput.vue?vue&type=template&id=4284998c", () => {
    api.rerender('4284998c', render)
  })

}


export default __exports__